<template>
  <Component :is="viewLayout">
    <template #page-heading>
      <h1 class="heading heading--large">
        Minha conta
      </h1>
    </template>

    <template #main>
      <div class="my-account">
        <WidgetAccount/>
      </div>
    </template>
  </Component>
</template>

<script>
import { layoutMixin } from '@/utils/mixins'
import WidgetAccount from '@/components/widget/WidgetAccount'

export default {
  name: 'MyAccountInsights',

  components: {
    WidgetAccount
  },

  mixins: [
    layoutMixin
  ]
}
</script>

<style lang="scss" scoped>
.my-account {}
</style>
